import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const Undo = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsx("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M6.60886 19H15.4649C18.5203 19 21 16.5151 21 13.4532C21 10.3914 18.5203 7.9065 15.4649 7.9065H3.28782M5.83395 10.6799L3 7.83994L5.83395 5",
            stroke: "currentColor",
            strokeWidth: 1.5 * (24 / size),
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
